var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPosTransactions = function SvgPosTransactions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.825.833c0-.372.302-.675.675-.675h5c.373 0 .675.303.675.675v2.5a.675.675 0 0 1-.675.675h-5a.675.675 0 0 1-.675-.675v-2.5Zm1.35.675v1.15h3.65v-1.15h-3.65ZM1 2.083h1.25v1.25h-.833v10.834h9.166V3.333h-.832v-1.25H11c.46 0 .832.373.832.834v11.666c0 .46-.373.834-.833.834H9.958v2.5c0 .345-.28.625-.625.625H2.667a.625.625 0 0 1-.625-.625v-2.5H1a.833.833 0 0 1-.833-.834V2.917c0-.46.373-.834.833-.834Zm2.292 13.334v1.875h5.416v-1.875H3.292ZM9.12 5.833H2.885v1.25H9.12v-1.25Z",
    fill: "#1D1737"
  })));
};
export default SvgPosTransactions;